<template>
    <div id="patients-portal-setup" class="page-height">
        <MdTitle v-bind:Text="$t('PPDbSetup.Title')" />

        <b-row>
            <b-col md="12" class="mx-auto">
                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <div :class="paneClass('contentGeneral')" id="contentGeneral" role="tabpanel">
                            <tab-general
                                v-model="editableItem.setup"
                                :messageTypeList="messageTemplateSetupList"
                                :messageTextTypeList="messageTextTemplateSetupList"
                                :isEmailValid="isEmailValid"
                            ></tab-general>
                        </div>
                        <div :class="paneClass('menuVisibility')" id="menuVisibility" role="tabpanel">
                            <tab-menu-visibility ref="menuTab"></tab-menu-visibility>
                        </div>
                        <div :class="paneClass('setupPayPal')" id="setupPayPal" role="tabpanel">
                            <tab-setup-pay-pal v-model="editableItem.payPal"></tab-setup-pay-pal>
                        </div>
                        <div :class="paneClass('formsPackages')" id="formsPackages" role="tabpanel">
                            <tab-forms-packages></tab-forms-packages>
                        </div>
                    </div>
                </MdTabList>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.BtnSave')"
                v-bind:Name="'btnSaveRole'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="saveOrEdit"
            />
        </div>
    </div>
</template>

<script>
import TabGeneral from './setup/tabGeneral.vue';
import TabSetupPayPal from './setup/tabSetupPayPal.vue';
import TabMenuVisibility from './setup/tabMenuVisibility.vue';
import TabFormsPackages from './setup/tabFormsPackages.vue';
import PatientPortalSetupService from '@/services/patientportalsetup.service.js';
import MessageTemplateSetupsService from '@/services/messagetemplatesetups.service';
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'PatientsPortalSetup',
    mixins: [ShowMessage, DBFunctions],
    components: {
        TabGeneral,
        TabSetupPayPal,
        TabMenuVisibility,
        TabFormsPackages
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: ''
            },
            tablist: [
                { title: this.$t('Shared.General'), link: '#contentGeneral', active: true },
                { title: this.$t('PPDbSetup.TabList.MenuVisibility'), link: '#menuVisibility' },
                { title: this.$t('PPDbSetup.TabList.SetupPayPal'), link: '#setupPayPal' },
                { title: this.$t('Shared.Packages'), link: '#formsPackages' }
            ],
            editableItem: {
                setup: null,
                firstPay: null,
                evo: null,
                payPal: null
            },
            activeTab: 1,
            activePaneId: 'contentGeneral',
            messageTemplateSetupList: [],
            messageTextTemplateSetupList: [],
            isEmailValid: true,
            pendingChanges: false,
            wasSaved: false
        };
    },
    computed: {
    },
    methods: {
        tabListChanged(event) {
            this.activeTab = event.activeTabNo;
            this.tablist.forEach((tab, index) => {
                tab.active = index + 1 === event.activeTabNo;
            });
            this.activePaneId = this.tablist[event.activeTabNo - 1].link.replace('#', '');
        },

        paneClass(paneId) {
            return this.activePaneId === paneId ? 'tab-pane fade show active' : 'tab-pane fade';
        },

        async saveOrEdit() {
            if (this.validate_required()) {
                await this.addOrUpdate();
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        async addOrUpdate() {
            const data = {
                setup: this.editableItem.setup,
                payPal:
                    this.editableItem.payPal === null ||
                    (Utils.isNullOrEmptyString(this.editableItem.payPal.clientId) &&
                        Utils.isNullOrEmptyString(this.editableItem.payPal.clientSecret))
                        ? null
                        : this.editableItem.payPal,
                menu: this.$refs.menuTab.getMenuItemsChanges()
            };

            await PatientPortalSetupService.addOrUpdate(data)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;
                        this.$refs.menuTab.markAsSaved();

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.isEmailValid =
                Utils.isNullOrEmptyString(this.editableItem.setup?.contactMessagesEmail) ||
                Utils.ValidateEmail(this.editableItem.setup?.contactMessagesEmail);

            return this.isEmailValid;
        },

        async getMessageTemplateSetupAsync() {
            let params = {
                SendTo: 'PATIENT',
                ShowIn: 'PATIENTPORTAL'
                //NotificationType: 'EMAIL'
            };

            await MessageTemplateSetupsService.getAll(params)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.messageTemplateSetupList = response.data
                            .filter(x => x.notificationType.toUpperCase() === 'EMAIL')
                            .map(x => ({
                                value: x.messageType,
                                text: x.description
                            }));
                        this.messageTextTemplateSetupList = response.data
                            .filter(x => x.notificationType.toUpperCase() === 'TEXT')
                            .map(x => ({
                                value: x.messageType,
                                text: x.description
                            }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        initializeEvents() {
            this.$nextTick(() =>
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        this.pendingChanges |= e.Changed;
                    }.bind(this)
                )
            );
        },

        async loadInitialInfoAsync() {
            await PatientPortalSetupService.getAllInfo()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.editableItem = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },
    created() {
        EventBus.$on(
            'onResetTabList',
            function(item) {
                this.tabListChanged(item);
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },
    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const requestedTabIndex = this.tablist.findIndex(
            tab => tab.link === `#${this.$route.query.tab}`
        );
        this.tabListChanged({ activeTabNo: requestedTabIndex !== -1 ? requestedTabIndex + 1 : 1 });
        Promise.allSettled([
            this.loadInitialInfoAsync(),
            this.getMessageTemplateSetupAsync()
        ]).then(() => this.initializeEvents());
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
        EventBus.$off('onResetTabList');
    },
    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('PPDbSetup.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.saveOrEdit();

                        if (this.wasSaved) {
                            next();
                        }
                    }
                });
        } else {
            next();
        }
    }
};
</script>
